import {useRef, useEffect, useContext} from 'react';
import { SoundContext } from '../SoundContext';

const usePlaySound = (audioPath)=>{
    const audioRef = useRef(null);
    const {isSoundOn} = useContext(SoundContext);

    useEffect(()=>{
        if(!audioPath.current){
            audioRef.current = new Audio(audioPath);
            audioRef.current.load();

            return ()=>{
                if(audioRef.current){//clean up after done using audio
                    audioRef.current.pause();
                    audioRef.current = null;
                }
            }

        }
    },[audioPath]);

    const playSound = ()=>{
        if(isSoundOn && audioRef.current){
            const audio = new Audio(audioPath);
            audio.play().catch(e=>console.error(`Sound playback error: `,e));
           
        }
    };

    return playSound;
};

export default usePlaySound